export default {
  'header_promotion_低价引爆Amazon流量': {
    cn: '低价引爆Amazon流量',
    en: 'Getting more traffic with  a low cost ',
    kr: 'Getting more traffic with  a low cost '
  },
  'header_promotion_ASIN关键词精准反查': {
    cn: 'ASIN关键词精准反查',
    en: 'Reverse ASIN keywords',
    kr: 'Reverse ASIN keywords'
  },
  'header_promotion_广告调优全自动': {
    cn: '广告调优全自动',
    en: 'Optimize campaign automatically',
    kr: 'Optimize campaign automatically'
  },
  'header_promotion_独家关键词监控卡位': {
    cn: '独家关键词监控卡位',
    en: 'Exclusive Ranking monitor',
    kr: 'Exclusive Ranking monitor'
  },
  'header_promotion_运营报表日更新': {
    cn: '运营报表日更新',
    en: 'Updating operations report',
    kr: 'Updating operations report'
  },
  'header_promotion_智能分时调价节预算': {
    cn: '智能分时调价节预算',
    en: 'Intelligent bid & budget adjustment',
    kr: 'Intelligent bid & budget adjustment'
  },
  'header_promotion_专属广告资询师': {
    cn: '专属广告资询师',
    en: 'Exclusive advertising consultant',
    kr: 'Exclusive advertising consultant'
  },
  'header_promotion_': {
    cn: '',
    en: '',
    kr: ''
  },
  'header_ai_assistant': {
    cn: 'AI助手',
    en: 'AI Assistant',
    kr: 'AI 어시스턴트'
  }
}
